import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.integration.index'),
        name: 'integration.index',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "integrations" */ '@/views/integrations/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.integration.breadcrumb.index'),
                    disable: true,
                },
            ],
        },
    },

    {
        path: '/' + i18n.t('routes.integration.edit') + '/:id',
        name: 'integration.edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "integrations" */ '@/views/integrations/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.integration.breadcrumb.index'),
                    disable: false,
                    to: { name: 'integration.index' },
                },
                {
                    text: i18n.t('routes.integration.breadcrumb.edit'),
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
